import * as S from "./RadialChart.style";
import { Charts } from "..";
import { useState } from "react";
import * as echarts from "echarts/core";
import ReactECharts from "echarts-for-react";

interface RadialChartProps {
  title?: string;
  data?: any;
  status?: string;
  color?: "yellow" | "green" | "red";
}

export const RadialChart = ({
  title,
  data,
  status,
  color,
}: RadialChartProps) => {
  const [options, setOptions] = useState({
    color: "#5C79EF",
    series: [
      {
        type: "gauge",
        radius: "100%",
        startAngle: 90,
        endAngle: -360,
        center: ["50%", "50%"],
        min: data.minValue,
        max: data.maxValue,
        progress: {
          show: true,
          width: 5,
        },
        detail: {
          // data.value의 css 부분
          show: true,
          valueAnimation: true,
          color: "#03071B",
          fontSize: "1.6rem",
          fontWeight: "600",
          offsetCenter: [0, "-6px"], // data.value의 세로 위치를 정하는 부분 | 양수: 아래로, 음수: 위로
        },
        data: [data.value],
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 5,
            color: [[1, "#F6F7FA"]],
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        pointer: {
          show: false,
        },
      },
    ],
  });

  const statusLabel =
    status === "good"
      ? "정상"
      : status === "warn"
      ? "주의"
      : status === "danger"
      ? "위험"
      : "";

  return (
    <Charts title={title} status={statusLabel}>
      <S.RadialChart>
        <ReactECharts
          echarts={echarts}
          option={options}
          opts={{ renderer: "svg" }}
          style={{ width: "100%", height: "100%" }}
        />
        <S.RadialChartUnit $color={color}>{data.unit}</S.RadialChartUnit>
      </S.RadialChart>
    </Charts>
  );
};
